import script from "./UserViewNew.vue?vue&type=script&setup=true&lang=js"
export * from "./UserViewNew.vue?vue&type=script&setup=true&lang=js"

import "./UserViewNew.vue?vue&type=style&index=0&id=462b6a19&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-462b6a19"]])

export default __exports__